<template>
  <div class="form-item" v-show="visible">
    <el-form
      ref="childForm"
      @submit.native.prevent
      :rules="rules"
      :model="formLabelAlign"
      label-position="top"
    >
      <el-form-item :label="localized(`label`)" prop="value">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top-start"
          v-if="fatherContent.displayReference.description"
        >
          <div slot="content">{{fatherContent.displayReference.description}}</div>
          <img class="form-tooltip" :src="require('@/assets/question.png')" />
        </el-tooltip>
        <div class="ve-select"
             v-bind:class="{ ve_disable: disabled || vidDisable}"
             @click="callSelect">
          {{showtext}}
          <i class="el-icon-arrow-right scan" style="opacity: .5"></i>
          <span
            style="color: rgb(198, 202, 209)"
            v-if="itemdata == ''"
          >{{fatherContent.displayReference.prompt || ''}}</span>
        </div>
      </el-form-item>
    </el-form>
    <mt-actionsheet
      cancelText="cancel"
      closeOnClickModal="true"
      :actions="dataSource"
      v-model="sheetVisible"
    ></mt-actionsheet>
  </div>
</template>

<script>
import utils from "@/utils";
import language from "@/lang";
import callApp from "@/services/sdk";
import {mapGetters} from "vuex";

export default {
  uuid: "00000000-0000-0000-0000-000000100012",
  props: ["jsonContent", "fatherContent", "datamodel", "disabled", "host", "contextData", "editStatus"],
  components: {},
  data() {
    return {
      itemdata: "",
      formLabelAlign: {
        value: ""
      },
      dataSource: [
        {
          name: this.$t("app.no_data"),
          value: -1
        }
      ],
      sheetVisible: false,
      selectedData: {}
    };
  },
  computed: {
    ...mapGetters({
      formStatus: "getFormStatus",
      dataPointType: "getDataPointType"
    }),
    rules() {
      return {
        value: [
          {
            required: this.fatherContent.controlReference.required,
            message: "Required",
            trigger: "change"
          }
        ]
      };
    },
    showtext() {
      const filter = this.dataSource.filter(
        item => this.itemdata === item.value
      )[0];
      return filter && filter.name;
    },
    visible() {
      if (this.fatherContent.itemType) {
        return this.fatherContent.itemType.displayReference.visible;
      }
      return this.fatherContent.displayReference.visible;
    },
    hostKey(){
      return this.host + "." + this.fatherContent.key
    },
    vidDisable() {
      return this.dataPointType === 'bind' && (this.formStatus === 'submitedit')
    }
  },
  watch: {
    formLabelAlign: {
      handler(val) {
        this.$emit("fatherCall", {
          key: this.fatherContent.key,
          value: val.value
        });
      },
      deep: true
    }
  },
  methods: {
    localized(key) {
      return language.localize(
        this.$store.state,
        this.fatherContent.key,
        key,
        this.fatherContent.displayReference[key]
      );
    },
    callSelect() {
      if (this.disabled || this.vidDisable) {
        return;
      }
      this.sheetVisible = true;
    },
    setValue(select) {
      if (select.value === -1) return;
      this.itemdata = select.value;
      const filter = this.dataSource.filter(
        item => select.value === item.value
      )[0];
      this.selectedData = {
        key: this.fatherContent.key,
        value: { uuid: filter.uuid, datavid: filter.value }
      };
      this.formLabelAlign.value = [
                {
                  uuid: filter.uuid,
                  datavid: filter.value,
                  datauuid: filter.uuid,
                  datahash: filter.datahash,
                  txid: filter.txid,
                  clauseindex: filter.clauseindex
                }
        ];
      this.$emit("fatherCall", {
        key: this.fatherContent.key,
        value: [
                {
                  uuid: filter.uuid,
                  datavid: filter.value,
                  datauuid: filter.uuid,
                  datahash: filter.datahash,
                  txid: filter.txid,
                  clauseindex: filter.clauseindex
                }
        ]
      });
    }
  },
  created() {},
  mounted() {

    this.itemdata = this.datamodel && this.datamodel[0].datavid || ""
    this.formLabelAlign.value = this.datamodel

    const dataSource = this.fatherContent.controlReference.dataSource.filter(
      item => item.indexOf("Remote") > -1
    );
    if (!dataSource.length) return;
    if (dataSource[0] === "Remote.SKUList") {
  //       this.dataSource = [
  //   {
  //     "skuDescription": "",
  //     "skuDataHash": "233c7db509a079245cb04bc38c7af8b31fc9a3840455a24582d475fab18e2b03",
  //     "skuSnapshotUuid": "00000000-8fbc-49f7-8521-937503200000",
  //     "skuBizDataId": "908acb3f-8537-4f15-9a9d-14cf76d50724",
  //     "skuDataUuid": "00000000-21c9-4e72-bfa0-143302200000",
  //     "skuImage": "461a450f102a9d54782d48b9c30ae5af2e69daeed706572d892d46569efc8495",
  //     "skuDataVid": "0x74ce816d0015997947527f65928d41b96d03deb626e0d0805ffad845273adc1b",
  //     "skuclauseIndex": "0",
  //     "skuTxid": "0xc9dc55e9da6aca9f44e733bcaf20e565304b9f190c1e87c3420551463a253b98",
  //     "skuCode": "20200914",
  //     "skuName": "炒蛋的番茄"
  //   }
  // ].map(sku => {
  //             return {
  //             name: sku.skuName + ` ( ${sku.skuCode || ""} ) `,
  //             value: sku.skuDataVid,
  //             uuid: sku.skuDataUuid,
  //             method: this.setValue
  //             };
  //     });

      callApp(
        "getData",
        {
          type:
            "dataSource.server." + dataSource[0].split(".")[1].toLowerCase(),
          data: {}
        },
        "cbGetData"
      ).then(data => {
        //   this.selectedData = data
        this.dataSource =
          data.skulist &&
          data.skulist.map(sku => {
            return {
              name:
                (sku.skuName ? sku.skuName : "") + ` ( ${sku.skuCode || ""} ) `,
              value: sku.skuDataVid,
              uuid: sku.skuDataUuid,
              datahash: sku.skuDataHash,
              txid: sku.skuTxid,
              clauseindex: ~~sku.skuclauseIndex,
              method: this.setValue
            };
            // && this.datamodel[0].datavid || "012345"
          });

          // if(this.datamodel && this.datamodel.length){
          //   this.$emit("fatherCall", {
          //     key: this.fatherContent.key,
          //     value: this.datamodel
          //   });
          // }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
